// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cFoxI","name":"styles_name__2UylF","phone":"styles_phone__1Q2f5"};